/**

  ___                       _      ___       _        
 |   \ _  _ _ _  __ _ _ __ (_)__  |   \ __ _| |_ __ _ 
 | |) | || | ' \/ _` | '  \| / _| | |) / _` |  _/ _` |
 |___/ \_, |_||_\__,_|_|_|_|_\__| |___/\__,_|\__\__,_|
       |__/
       
*/

import { FolderAssetDTO, FolderDTO, AssetFolderService, FolderItemDTO } from '../service/folder';
import { VisionWindowManager } from './manager';
import { VisionWindow } from './window';

export class VisionAssetFolderWindow extends VisionWindow {
    nullUUID = '00000000-0000-0000-0000-000000000000';

    assetCache!: Map<string, FolderAssetDTO>;
    folderCache!: Map<string, FolderDTO>;
    assetFolderService: AssetFolderService;

    activeFolder: FolderDTO | undefined;

    // UI Elements
    layout!: dhtmlXLayoutObject;
    layoutDragDrop!: dhtmlXLayoutObject;
    assigned!: dhtmlXTreeObject;
    unassigned!: dhtmlXGridObject;
    folders!: dhtmlXGridObject;
    toolbar?: dhtmlXToolbarObject;
    form!: dhtmlXForm;
    groupToolbar?: dhtmlXToolbarObject;
    assignedContextMenu?: dhtmlXMenuObject;
    primaryId!: string | undefined;

    /**
     *
     * @param manager
     */
    constructor(manager: VisionWindowManager) {
        const height = window.innerHeight - 100;
        const width = window.innerWidth - 100;

        super(manager, {
            id: 'edit_asset_folder_window',
            title: 'Asset Groupings',
            x: 10,
            y: 10,
            width: width,
            height: height,
        });
        this.window.setText('Asset Groupings');
        this.modal = true;
        this.assetFolderService = this.manager.app.assetFolderService;

        this.assetCache = new Map<string, FolderAssetDTO>();
        this.folderCache = new Map<string, FolderDTO>();
        this.activeFolder = undefined;
        this.primaryId = undefined;

        this.buildLayout();
        this.buildAssignedCell();
        this.buildUnassignedCell();
        this.buildFolderTree();
        this.buildAssetCache();
        this.buildForm();
        this.buildEvents();
        this.initialFolder();

        this.getFolders();
    }

    private buildLayout() {
        this.layout = this.window.attachLayout('3L');
        this.layout.cells('a').setText('Groupings');
        this.layout.cells('a').setWidth(350);
        this.layout.cells('a').hideHeader();
        this.layout.cells('b').setText('Details');
        this.layoutDragDrop = this.layout.cells('c').attachLayout('2U');
        this.layoutDragDrop.cells('b').setText('Available');

        this.toolbar = this.layout.cells('b').attachToolbar();
        this.toolbar.addButton('new', 0, 'New', 'icons/sign.png', '');
        this.toolbar.addButton('save', 1, 'Save', 'css/imgs/save.gif', '');
        this.toolbar.addSeparator('sep1', 2);
        this.toolbar.addButton('delete', 3, 'Delete', 'icons/clear.png', '');
        this.toolbar.attachEvent('onClick', (itemId) => {
            switch (itemId) {
                case 'save': {
                    this.saveFolder();
                    break;
                }
                case 'new': {
                    this.newFolder();
                    break;
                }
                case 'delete': {
                    this.deleteFolder();
                    break;
                }
            }
        });

        this.layout.cells('b').hideHeader();
    }

    /**
     *
     */
    private buildAssignedCell() {
        this.layoutDragDrop.cells('a').setText('Assigned');
        this.groupToolbar = this.layoutDragDrop.cells('a').attachToolbar();
        //this.groupToolbar.addButton('new', 0, "Add", "css/imgs/new.gif","");
        //this.groupToolbar.addButton('delete', 0, "Remove", "css/imgs/new.gif", "");

        this.assigned = this.layoutDragDrop.cells('a').attachTree();
        this.assigned.setImagesPath('css/imgs/dhxgrid_material/tree/');
        this.assigned.enableDragAndDrop(true, true);

        this.assignedContextMenu = new dhtmlXMenuObject();
        this.assignedContextMenu.setIconsPath('css/imgs/');
        this.assignedContextMenu.renderAsContextMenu();

        //this.assignedContextMenu.loadStruct('<menu id="0"><item text="Add Group" id="add_group"/><item text="Rename" id="edit_group"/></menu>');
        //this.assigned.enableContextMenu(this.assignedContextMenu);

        //this.assigned.attachEvent("onBeforeContextMenu", (id) => {
        //    return (this.assigned.getUserData(id, "type") == "group" &&
        //            this.assigned.getItemText(id) != "Default");
        //});

        this.assigned.attachEvent('onBeforeDrag', (id) => {
            return this.assigned.getItemText(id) != 'Default';
        });

        /*
        this.assigned.attachEvent('onDragIn', (_sId, tId, _sObject, _tObject) => {
            if (this.assigned.getUserData(tId, 'type') != 'group') {
                return false;
            }
            return true;
        });
        */

        //this.assigned.attachEvent('onDrop', (_sId, _tId, _dId, _sObj, _tObj, _sCol, _tCol) => {});

        this.assignedContextMenu.attachEvent('onClick', (menuItemId, _type) => {
            if (menuItemId == 'add_group') {
                const uuid = crypto.randomUUID();
                this.assigned.insertNewItem(this.assigned.contextID, uuid, 'New Group');
                this.assigned.setUserData(uuid, 'type', 'group');
                console.log('Added: ' + uuid);
                console.log(this.assigned.getUserData(uuid, 'type'));
            }
            if (menuItemId == 'edit_group') {
                this.assigned.editItem(this.assigned.contextID);
            }
        });

        // Make sure you can't drag a segment onto another segment.
        this.assigned.attachEvent('onDrop', (sId, tId, _sObject, _tObject) => {
            const type = this.unassigned.getUserData(tId, 'type');
            // If dragged on to the a segment than move the item to the parent
            // to make sure all segments are siblings
            if (type == 'asset') {
                const parent = this.assigned.getParentId(tId);
                this.assigned.moveItem(sId, 'item_child', parent, null);
                return true;
            } else if (tId == 0) {
                const rootId = (this.assigned.getSubItems(0) as unknown as string).split(',')[0];
                if (rootId != null) {
                    this.assigned.moveItem(sId, 'item_child', rootId, null);
                }
                return true;
            }

            return true;
        });

        this.assigned.enableItemEditor(true);
        this.assigned.setEditStartAction(false, false);
        this.assigned.enableMultiselection(true, true);

        // TODO change to read user data.
        this.assigned.setOnEditHandler((_state, id, _tree, _value) => {
            return this.assigned.getUserData(id, 'type') == 'group';
        });
    }

    private buildUnassignedCell() {
        this.unassigned = this.layoutDragDrop.cells('b').attachGrid();
        this.unassigned.setHeader('Name', '', []);
        this.unassigned.enableDragAndDrop(true);
        this.unassigned.enableMultiselect(true);

        this.unassigned.treeToGridElement = function (treeObj, treeNodeId, _gridRowId) {
            return [treeObj.getItemText(treeNodeId)];
        };
        this.unassigned.gridToTreeElement = function (_treeObj, _treeNodeId, gridRowId) {
            return this.cells(gridRowId, 0).getValue();
        };
        this.unassigned.rowToDragElement = function (id) {
            return this.cells(id, 0).getValue();
        };

        /** Called when element is dropped onto the unassigned table
         *  This will delete any items that are "groups-" so we do not get groups inside the
         *  asset list.
         */
        this.unassigned.attachEvent('onDrop', (_sId, _tId, _dId, _sObj, _tObj, _sCol, _tCol) => {
            this.unassigned.forEachRow((id) => {
                if (this.unassigned.getUserData(id, 'type') != 'asset') {
                    this.unassigned.deleteRow(id);
                }
            });
        });

        this.unassigned.setSerializationLevel(true, false, false, false, false, false);
        this.unassigned.init();
    }

    /**
     *
     */
    private buildFolderTree() {
        this.folders = this.layout.cells('a').attachGrid();
        this.folders.setHeader('Groupings,Description', '', []);
        this.folders.init();
    }

    private buildForm() {
        const form_data = [
            {
                type: 'settings',
                position: 'label-left',
                labelWidth: 200,
                inputWidth: 130,
            },
            {
                name: 'id',
                type: 'input',
                label: 'ID',
                value: '',
                inputWidth: '400',
                offsetLeft: '25',
                offsetTop: '25',
                disabled: true,
            },
            {
                name: 'name',
                type: 'input',
                label: 'Grouping Name',
                value: '',
                inputWidth: '400',
                offsetLeft: '25',
                validate: 'ValidAplhaNumeric',
                required: true,
            },
            {
                name: 'description',
                type: 'input',
                label: 'Description',
                value: '',
                rows: '3',
                inputWidth: '400',
                offsetLeft: '25',
            },
            {
                name: 'ispublic',
                type: 'checkbox',
                label: 'Public',
                checked: true,
                offsetLeft: '25',
            },
        ];
        this.form = this.layout.cells('b').attachForm({});
        this.form.loadStruct(form_data);

        this.form.attachEvent('onChange', (name, value, _state) => {
            if (name == 'name') {
                if (this.primaryId == undefined) {
                    this.newFolder();
                    this.form.setItemValue('name', value);
                }

                if (this.primaryId) {
                    this.assigned.setItemText(this.primaryId, value);
                }
            }
        });
    }

    private buildEvents() {
        this.folders.attachEvent('onRowSelect', (id, _idx) => {
            if (this.folderCache.has(id)) {
                const found = this.folderCache.get(id);
                console.log('Looking in cache for:' + id);
                console.log(found);
                this.populateFolderData(found);
            } else {
                console.log('Query Server');
                /*
                let folderRequest =  this.assetFolderService.getFolder(id);
                folderRequest.then ( data => {
                    if ( data.parsedBody ) {
                        this.folderCache.set(data.parsedBody.id, data.parsedBody);
                        console.log("Caching:");
                        console.log(data.parsedBody);
                        this.populateFolderData(data.parsedBody);
                    }
                });
                */
            }
        });
    }

    /**
     *
     */
    private buildAssetCache() {
        const assetResponse = this.assetFolderService.getAssetsForFolders();
        assetResponse.then((data) => {
            if (data.parsedBody) {
                this.assetCache.clear();
                for (let i = 0; i < data.parsedBody?.length; i++) {
                    this.assetCache.set(data.parsedBody[i].id, data.parsedBody[i]);
                }

                this.assetTableFromCache();
            }
        });
    }

    /**
     *
     */
    private assetTableFromCache() {
        this.unassigned.clearAll(false);
        this.assetCache.forEach((asset: FolderAssetDTO, _key: string) => {
            this.unassigned.addRow(asset.id, asset.name, 0, 0, '', false);
            this.unassigned.setUserData(asset.id, 'type', 'asset');
        });
        this.unassigned.sortRows(0, 'int', 'asc');
    }

    /**
     *
     */
    private getFolders(select?: string) {
        const folderRequest = this.assetFolderService.getFolders();
        folderRequest.then((data) => {
            if (data.parsedBody) {
                this.folders.clearAll(false);
                for (let i = 0; i < data.parsedBody?.length; i++) {
                    console.log('Caching');
                    console.log(data.parsedBody[i]);

                    this.folderCache.set(data.parsedBody[i].id, data.parsedBody[i]);
                    this.folders.addRow(data.parsedBody[i].id, [data.parsedBody[i].name, data.parsedBody[i].description], 0, 0, '', false);
                    if (select) {
                        this.folders.selectRowById(select, false, true, true);
                    }
                }
            }
        });
    }

    private populateFolderData(data: FolderDTO | undefined) {
        if (data == undefined) {
            return;
        }
        this.activeFolder = data;

        this.assetTableFromCache(); // Resets the asset table to full
        this.assigned.deleteChildItems(0);

        this.form.setItemValue('id', data.id);
        this.form.setItemValue('name', data.name);
        this.form.setItemValue('description', data.description);
        this.form.setItemValue('ispublic', data.public ? '1' : '0');

        const organized = this.organizeList(data);

        organized.organizedList?.forEach((gid) => {
            const groupData = organized.mapped.get(gid);
            if (groupData) {
                const id = groupData.parent == this.nullUUID ? 0 : groupData.parent;
                this.assigned.insertNewItem(id, groupData.id, groupData.name);
                this.assigned.setUserData(groupData.id, 'type', 'group');
            }
        });

        console.log('Rebuild Done');

        data.items?.forEach((assetData) => {
            //console.log("Asset Data");
            //console.log(assetData);
            this.assigned.insertNewItem(assetData.parent, assetData.id, assetData.name);
            this.assigned.setUserData(assetData.id, 'type', 'asset');
            this.unassigned.deleteRow(assetData.id);
        });
    }

    private initialFolder() {
        this.assigned.deleteChildItems('0');
        this.primaryId = crypto.randomUUID();
        this.assigned.insertNewItem(0, this.primaryId, 'Main');
        this.assigned.setUserData(this.primaryId, 'type', 'group');
    }

    private newFolder() {
        this.assetTableFromCache();
        this.assigned.deleteChildItems('0');
        this.primaryId = crypto.randomUUID();
        this.assigned.insertNewItem(0, this.primaryId, 'Main');
        this.assigned.setUserData(this.primaryId, 'type', 'group');
        this.form.setItemValue('id', null);
        this.form.setItemValue('name', null);
        this.form.setItemValue('description', null);
    }

    private saveFolder() {
        const treeData = JSON.parse(this.assigned.serializeTreeToJSON());
        const save = {} as FolderDTO;
        const groups = new Array<FolderItemDTO>();
        const assets = new Array<FolderItemDTO>();

        this.processTree(treeData, '0', groups, assets);

        save.branches = groups;
        save.items = assets;
        save.id = this.form.getItemValue('id');
        save.name = this.form.getItemValue('name');
        save.description = this.form.getItemValue('description');
        save.public = this.form.getItemValue('ispublic') == '1' ? true : false;

        if (this.assetFolderService.orgid == null) {
            console.log('No oganization id available');
        } else {
            save.organization = this.assetFolderService.orgid;
        }

        let request = undefined;
        if (save.id == '') {
            console.log('Saving');
            save.id = crypto.randomUUID();
            request = this.assetFolderService.save(save);
        } else {
            console.log('Updating');
            request = this.assetFolderService.update(save);
        }

        request.then((data) => {
            if (data?.ok) {
                this.getFolders(data.parsedBody?.id);

                dhtmlx.message({
                    title: 'Update Complete',
                    text: 'Folder ' + data.parsedBody?.name + ' was updated.',
                    type: 'alert-success',
                });
            }
        });
    }

    /**
     *
     */
    private deleteFolder() {
        const id = this.form.getItemValue('id');
        const deleted = this.folderCache.get(id);
        if (deleted == undefined) {
            return;
        }

        dhtmlx.confirm({
            type: 'confirm-warning',
            title: 'Confirm Delete',
            text: 'Delete Grouping: ' + deleted?.name + '?',
            callback: (result: boolean) => {
                if (result == true) {
                    const deleteRequest = this.assetFolderService.deleteFolder(deleted);

                    if (this.folderCache.has(id)) {
                        this.folderCache.delete(id);
                    }

                    deleteRequest.then((_data) => {
                        this.getFolders();
                        this.newFolder();

                        dhtmlx.message({
                            title: 'Complete',
                            text: 'Group Removed.',
                            type: 'alert-success',
                        });
                    });
                }
            },
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private processTree(treeitem: any, parent: string, groups: FolderItemDTO[], assets: FolderItemDTO[]) {
        for (const key in treeitem) {
            if (key == 'text') {
                const id = treeitem['id'];
                console.log('Item: ' + this.assigned.getItemText(id));

                const itemType = this.assigned.getUserData(id, 'type') == undefined ? this.unassigned.getUserData(id, 'type') : this.assigned.getUserData(id, 'type');
                console.log(itemType);
                if (itemType == 'group') {
                    groups.push({ id: id, name: treeitem['text'], parent: parent });
                } else if (itemType == 'asset') {
                    assets.push({ id: id, name: treeitem['text'], parent: parent });
                }
                parent = id;
            }
            if (key == 'item') {
                for (const item of treeitem['item']) {
                    this.processTree(item, parent, groups, assets);
                }
            }
        }
    }

    private organizeList(data: FolderDTO) {
        console.log('Organizing List');

        const branches = [...data.branches];
        const organizedList = new Array<string>();
        const mapped = new Map<string, FolderItemDTO>();
        data.branches?.forEach((groupData) => {
            mapped.set(groupData.id, groupData);
        });

        while (branches.length > 0) {
            console.log('Branches Left: ' + branches.length);
            const groupData = branches.shift();
            console.log('Working with');
            console.log(groupData);
            if (groupData) {
                // If no parent than we are good.
                if (groupData.parent == this.nullUUID) {
                    if (organizedList.includes(groupData.id) == false) {
                        organizedList.push(groupData.id);
                    }
                } else {
                    // If we have a parent and in the list ok,  if not push into the end of the list.
                    if (organizedList.includes(groupData.parent)) {
                        organizedList.push(groupData.id);
                    } else {
                        branches.push(groupData);
                    }
                }
            }
        }

        return { organizedList: organizedList, mapped: mapped };
    }
}
